import Quill from '../quill'
const Block = Quill.import('blots/block/embed')

class FileBlot extends Block {
  static create (data) {
    let node = super.create(data)
    node.setAttribute('style', 'color: #6d2ef8;cursor:pointer')
    node.setAttribute('url', data.url)
    node.setAttribute('contenteditable', false)
    node.setAttribute('length', data.size)
    node.setAttribute('uploadType', 'uploadFile')
    node.innerText = data.name
    return node
  }

  // 返回节点自身的value值 用于撤销操作
  static value (node) {
    const url = node.getAttribute('url')
    const length = node.getAttribute('length')
    const name = node.innerText
    const data = {
      url: url,
      size: length,
      name: name
    }
    return data
  }
}



FileBlot.blotName = 'uploadFile'
FileBlot.tagName = 'p'
FileBlot.className = 'ks-quill-upload-file'

export default FileBlot



// WEBPACK FOOTER //
// ./src/public/components/kye-editor-new/blot/upload-file.js